import {WhatsappAuthorizationResponse} from '../../../../api/proto';
import i18n from '../../../../i18n';

const {t} = i18n;

export const getWhatsappAuthError = (type?: WhatsappAuthorizationResponse.Status | null): string => {
  switch (type) {
    case WhatsappAuthorizationResponse.Status.INVALID_CODE:
      return t('api_whatsapp_authorization_invalid_code');
    case WhatsappAuthorizationResponse.Status.ACCESS_NOT_GRANTED:
      return t('api_whatsapp_authorization_access_not_granted');
    case WhatsappAuthorizationResponse.Status.NO_CONNECTED_ACCOUNTS:
      return t('api_whatsapp_authorization_no_connected_accounts');
    case WhatsappAuthorizationResponse.Status.INTERNAL_ERROR:
      return t('api_whatsapp_authorization_internal_error');
  }

  if (type && WhatsappAuthorizationResponse.Status[type]) {
    return WhatsappAuthorizationResponse.Status[type]?.toLowerCase().replace(/_/g, ' ');
  }

  return '';
};

export default getWhatsappAuthError;
